import classNames from "classnames";
import React from "react";

import * as styles from "./styles.module.scss";

const ProgressBar: React.FC<{ loading: boolean }> = ({ loading }) => (
  <div className={classNames(styles.container, loading ? styles.loading : styles.done)}>
    <div className={styles.loadingBar} />
  </div>
);

export default ProgressBar;
